<template><div class="map-el">
  <div id="map" ref="map" />
  <unit-marker
      v-for="(uid,i) in units"
      :key="`gmap-marker-${i}-${uid}`"
      :google="google"
      :map="map"
      :uid="uid"
      :coords="coords"
      :gps="gps"
      :speed="speed"
    />
  <poi-marker
      v-for="(p,i) in pois"
      :key="`poi-${i}-${p.id}`"
      :google="google"
      :map="map"
      :poi="p"
      :coords="coords"
    />
  <poi-marker
      v-if="poi"
      :key="`poi-edit-${poi.id}`"
      :google="google"
      :map="map"
      :poi="poi"
      :editable="true"
      @noAutoZoom="autoZoom=false"
    />
</div></template>
<script>
import Coords from '../Coords'
import { mapGetters, mapState } from 'vuex'
import PoiMarker from './PoiMarker'
import UnitMarker from './UnitMarker'
let GoogleMapsLoader = require('google-maps')
GoogleMapsLoader.KEY = 'AIzaSyDmcG8dwXkMdV_PMEjP3lsYa5y-3wcaQHc'
GoogleMapsLoader.VERSION = 'quarterly'
GoogleMapsLoader.LIBRARIES = ['geometry']

let google = null,
  maxZoom = null
export let Google = new Promise((y,n) => {
  if (google) {
    y(google)
  } else {
    GoogleMapsLoader.load(g => {
      google = g
      maxZoom = new google.maps.MaxZoomService()
      y(google)
    })
  }
})

function AutoControl(controlDiv, map, data) {

  // Set CSS for the control border.
  var controlUI = document.createElement('div')
  controlUI.className = 'control-ui'
  controlUI.title = 'Click to let the map zoom automatically.'
  controlDiv.appendChild(controlUI)

  // Set CSS for the control interior.
  var controlText = document.createElement('div')
  controlText.className = 'control-text'

  controlText.innerHTML = 'Auto'
  controlUI.appendChild(controlText)

  // Setup the click event listener.
  controlUI.addEventListener('click', function() {
    data.autoZoom = true
  })

}

export default {
  name: 'g-map',
  props: {
    unitId:{default:false},
    tracklog:{default:0},
    poi:{default:false},
    showUnits:{default:true},
    fleet:{default:null},
    gps:{default:false},
    speed:{default:false},
  },
  data() {
    return {
      coords: new Coords(),
      tracklogListeners: this.createTracklogListeners(),
      polyline: null,
      polylineBounds: null,
      google: null,
      map: null,
      autoZoom: true,
      autoControlDiv: null,
      dropped: null,
    }
  },
  computed: {
    ...mapState(['selectedPoi','poiBounds']),
    units() {
      if (this.map === null) return []
      if (!this.showUnits) return []
      if (this.unitId === false) {
        return this.$store.state.uids_sorted_by_uid.slice()
      } else {
        let u = this.$store.state.units[this.unitId]
        if (u) return [this.unitId]
        else return []
      }
    },
    pois() {
      if (this.map === null)
        return []
      if (this.fleet)
        return this.fleet.pois.filter(p => (p.id !== (this.poi && this.poi.id)))
      let rv = []
      for (const k in this.$store.getters.pois) {
        const p = this.$store.getters.pois[k]
        if (p.id !== (this.poi && this.poi.id))
          rv.push(p)
      }
      return rv
    },
    bounds() {
      if (this.map === null) return null
      if (this.selectedPoi !== null && this.poiBounds[this.selectedPoi])
        return this.poiBounds[this.selectedPoi]
      let bounds = new google.maps.LatLngBounds()
      if (this.coords.north) {
        bounds.extend({ lat: this.coords.north, lng: this.coords.east })
        bounds.extend({ lat: this.coords.south, lng: this.coords.west })
      }
      if (this.polylineBounds)
        bounds.union(this.polylineBounds)
      return !bounds.isEmpty()
        ? bounds
        : new google.maps.LatLngBounds(
          { lat: 24, lng: -128 },
          { lat: 50, lng: -64 },
        )
    },
    filterUnitName() {
      return this.$store.state.filterUnitName
    },
  },
  methods: {
    createTracklogListeners() {
      if (this.tracklog) {
        return [
          this.tracklog.addListener('insert_at', this.tracklogInsertAtEvent),
          this.tracklog.addListener('remove_at', this.tracklogRemoveAtEvent),
        ]
      } else {
        return []
      }
    },
    clearTracklogListeners() {
      for (let l of this.tracklogListeners) {
        l.remove()
      }
    },
    tracklogInsertAtEvent(i) {
      let c = this.tracklog.getAt(i)
      c = new google.maps.LatLng(c[1], c[2])
      this.polyline.getPath().insertAt(i, c)
      this.polylineBounds.extend(c)
    },
    tracklogRemoveAtEvent(i, o) {
      this.polyline.getPath().removeAt(i)
    },
    dragged() {
      this.autoZoom = false
    },
    zoomChanged() {
      if (this.autoZoom === true)
        this.autoZoom = false
      else if (this.map.getZoom() > 19)
        this.map.setZoom(19)
      else if (this.autoZoom === 'zooming')
        this.autoZoom = true
      maxZoom.getMaxZoomAtLatLng(this.map.getCenter(), r => {
        if (!this.autoZoom || r.status !== 'OK') return
        if (r.zoom < this.map.getZoom()) {
          this.autoZoom = 'zooming'
          this.map.setZoom(r.zoom)
        }
      })
    },
    doAutoZoom() {
      if (this.autoZoom !== true) return
      this.autoZoom = 'zooming'
      this.map.fitBounds(this.bounds)
    },
    click(e) {
      this.$store.commit('selectPoi', null)
      if (this.dropped) {
        this.dropped.marker.setMap(null)
        this.dropped = null
        return
      }
      this.dropped = {
        marker: new google.maps.Marker({
          position: e.latLng,
          map: this.map,
        }),
        infowindow: new google.maps.InfoWindow({
          content: `<a target="_blank" class="directions" href="https://www.google.com/maps/dir/?api=1&destination=${e.latLng.lat()},${e.latLng.lng()}">Get directions to ${e.latLng.lat().toFixed(5)}, ${e.latLng.lng().toFixed(5)}</a>`
        }),
      }
      this.dropped.infowindow.open(this.map, this.dropped.marker)
      this.dropped.marker.addListener('click', () => {
        this.dropped.infowindow.open(this.map, this.dropped.marker)
      })
      this.autoZoom = false
    },
    getBounds() {
      if (!this.map) return null
      return this.map.getBounds()
    },
  },
  watch: {
    bounds(nv) {
      if (this.map === null) return
      this.doAutoZoom()
    },
    filterUnitName() {
      this.autoZoom = true
      this.doAutoZoom()
    },
    autoZoom(nv, ov) {
      if (nv && !ov && this.bounds !== null)
        this.doAutoZoom()
      if (nv)
        this.autoControlDiv.className = 'active'
      else
        this.autoControlDiv.className = ''
    },
    '$store.state.selectedUnit': function() {
      this.autoZoom = true
      if (this.dropped) {
        this.dropped.marker.setMap(null)
        this.dropped = null
      }
    },
    tracklog(nv, ov) {
      this.clearTracklogListeners()
      this.tracklogListeners = this.createTracklogListeners()
      if (this.polyline !== null) {
        this.polyline.setMap(null)
      }
      this.polylineBounds = new google.maps.LatLngBounds()
      let coords = []
      if (nv) {
        for (let c of nv.getArray()) {
          c = new google.maps.LatLng(c[1], c[2])
          coords.push(c)
          this.polylineBounds.extend(c)
        }
      }
      this.polyline = new google.maps.Polyline({
        path: coords,
        strokeColor: '#ff0000',
        strokeOpacity: 1.0,
        strokeWeight: 2,
      })
      this.polyline.setMap(this.map)
    },
    selectedPoi(nv) {
      if (nv) {
        this.autoZoom = true
        this.doAutoZoom()
      }
    },
  },
  async mounted() {
    this.$store.commit('selectPoi', null)
    this.google = await Google
    this.map = new google.maps.Map(this.$refs.map, {
      center: {lat: 40, lng: -90},
      zoom: 4,
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeId: 'hybrid',
      mapTypeControl: true,
      mapTypeControlOptions: {
      },
    })

    this.autoControlDiv = document.createElement('div')
    if (this.autoZoom)
      this.autoControlDiv.className = 'active'
    let autoControl = new AutoControl(this.autoControlDiv, this.map, this)
    this.autoControlDiv.index = 1
    this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(this.autoControlDiv)

    this.map.addListener('drag', () => { this.dragged() })
    this.map.addListener('zoom_changed', () => { this.zoomChanged() })
    this.map.addListener('click', this.click)
  },
  destroyed() {
  },
  components: {
    PoiMarker,
    UnitMarker,
  },
}
</script>
<style lang="scss">
.map-el, #map {
  width: 100%;
  height: 100%;
}

@keyframes active {
  from {
    background: #fff;
  }
  to {
    background: #afa;
  }
}

.control-ui {

  background-color: #fdd;
  border: 2px solid #fff;
  border-radius: 3px;
  box-shadow: 0 2px 6x rgba(0,0,0,.3);
  cursor: pointer;
  margin: 10px;
  text-align: center;

  .active & {
    animation: active 1s linear infinite alternate;
  }

  .control-text {
    color: rgb(25,25,25);
    font-family: Roboto,Arial,sans-serif;
    font-size: 16px;
    line-height: 38px;
    padding-left: 5px;
    padding-right: 5px;
  }
}

a.directions {
  text-decoration: underline;
}

</style>
